function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "number"
}, /*#__PURE__*/React.createElement("text", {
  transform: "translate(54.366 -282.265)",
  fontSize: 40,
  fill: "#24253a",
  fontFamily: "MyriadPro-Regular, Myriad Pro",
  letterSpacing: "0.002em"
}, "4", /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 228
}, "14"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 456
}, "24"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 684
}, "34"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 912
}, "44"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1140
}, "54"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1368
}, "64"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1596
}, "74"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 1824
}, "84"), /*#__PURE__*/React.createElement("tspan", {
  x: -10.3,
  y: 2052
}, "94"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2280
}, "104"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2508
}, "114"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2736
}, "124"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 2964
}, "134"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3192
}, "144"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3420
}, "154"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3648
}, "164"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 3876
}, "174"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4104
}, "184"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4332
}, "194"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4560
}, "204"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 4788
}, "214"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 5016
}, "224"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 5244
}, "234"), /*#__PURE__*/React.createElement("tspan", {
  x: -20.599,
  y: 5472
}, "244")));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64,1a63,63,0,0,0,0,126q1.6,0,3.171-.078A63,63,0,0,0,64,1Z",
  fill: "#ef5361"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M127,64a63,63,0,0,1-59.83,62.92c-1.05.05-2.11.08-3.17.08A63.027,63.027,0,0,1,6.08,88.83a62.779,62.779,0,0,0,42.13,16.15c1.06,0,2.12-.03,3.17-.08a63.039,63.039,0,0,0,54.75-87.75A62.894,62.894,0,0,1,127,64Z",
  fill: "#da2a47"
})), /*#__PURE__*/React.createElement("path", {
  d: "M82.893,7.3a1,1,0,0,1-.33-1.944q1.64-.574,3.283-1.088a1,1,0,0,1,.6,1.908q-1.611.505-3.221,1.068A1,1,0,0,1,82.893,7.3Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.289,12.735a1,1,0,0,1-.384-1.924c1.775-.737,3.585-1.43,5.38-2.059a1,1,0,1,1,.662,1.887c-1.76.618-3.535,1.3-5.275,2.02A1,1,0,0,1,79.289,12.735Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.052,18.331a1,1,0,0,1-.436-1.9c1.722-.833,3.479-1.624,5.224-2.35a1,1,0,1,1,.769,1.847c-1.71.711-3.433,1.486-5.122,2.3A.989.989,0,0,1,76.052,18.331Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.184,24.071A1,1,0,0,1,72.7,22.2c1.659-.924,3.36-1.81,5.057-2.633a1,1,0,1,1,.873,1.8c-1.664.807-3.331,1.675-4.957,2.58A1,1,0,0,1,73.184,24.071Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.682,29.938a1,1,0,0,1-.537-1.844c1.6-1.016,3.241-1.994,4.878-2.907A1,1,0,0,1,76,26.934c-1.6.9-3.213,1.854-4.781,2.849A.994.994,0,0,1,70.682,29.938Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.548,35.916a1,1,0,0,1-.585-1.812c1.532-1.1,3.109-2.168,4.688-3.172a1,1,0,0,1,1.073,1.687c-1.547.984-3.093,2.03-4.593,3.109A1,1,0,0,1,68.548,35.916Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.781,41.984a1,1,0,0,1-.63-1.777c1.463-1.186,2.972-2.339,4.485-3.429A1,1,0,0,1,71.806,38.4c-1.483,1.068-2.962,2.2-4.4,3.359A.994.994,0,0,1,66.781,41.984Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.382,48.128a1,1,0,0,1-.674-1.739c1.387-1.265,2.825-2.5,4.271-3.675a1,1,0,0,1,1.261,1.553c-1.417,1.15-2.826,2.362-4.186,3.6A1,1,0,0,1,65.382,48.128Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.351,54.33a1,1,0,0,1-.715-1.7c1.308-1.339,2.669-2.655,4.046-3.912A1,1,0,0,1,69.03,50.2c-1.349,1.231-2.682,2.521-3.964,3.833A1,1,0,0,1,64.351,54.33Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.687,60.571a1,1,0,0,1-.754-1.656c1.232-1.417,2.513-2.809,3.808-4.137a1,1,0,0,1,1.432,1.4c-1.268,1.3-2.523,2.664-3.731,4.053A1,1,0,0,1,63.687,60.571Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.391,66.835a1,1,0,0,1-.792-1.611c1.146-1.485,2.343-2.949,3.559-4.351a1,1,0,1,1,1.511,1.311c-1.191,1.373-2.364,2.806-3.486,4.262A1,1,0,0,1,63.391,66.835Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.461,73.1a1,1,0,0,1-.825-1.563c1.055-1.548,2.165-3.08,3.3-4.553a1,1,0,0,1,1.585,1.22c-1.11,1.442-2.2,2.942-3.23,4.459A1,1,0,0,1,63.461,73.1Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.9,79.362a1,1,0,0,1-.857-1.513c.965-1.614,1.983-3.209,3.025-4.742a1,1,0,0,1,1.654,1.124c-1.021,1.5-2.018,3.063-2.963,4.644A1,1,0,0,1,63.9,79.362Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.707,85.589a1,1,0,0,1-.886-1.461c.869-1.671,1.792-3.326,2.741-4.917a1,1,0,1,1,1.718,1.024c-.93,1.559-1.833,3.179-2.685,4.816A1,1,0,0,1,64.707,85.589Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.882,91.771a1,1,0,0,1-.913-1.407c.763-1.713,1.586-3.422,2.445-5.08a1,1,0,1,1,1.775.92c-.841,1.624-1.646,3.3-2.394,4.974A1,1,0,0,1,65.882,91.771Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.424,97.888a1,1,0,0,1-.937-1.352c.66-1.76,1.379-3.519,2.137-5.228a1,1,0,1,1,1.828.812c-.743,1.673-1.447,3.4-2.092,5.118A1,1,0,0,1,67.424,97.888Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.334,103.923a1,1,0,0,1-.957-1.293c.551-1.8,1.163-3.6,1.817-5.362a1,1,0,1,1,1.874.7c-.641,1.72-1.24,3.486-1.779,5.249A1,1,0,0,1,69.334,103.923Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.611,109.859a1.016,1.016,0,0,1-.234-.027,1,1,0,0,1-.74-1.206c.439-1.835.939-3.679,1.486-5.479a1,1,0,0,1,1.914.581c-.536,1.762-1.025,3.566-1.455,5.363A1,1,0,0,1,71.611,109.859Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.255,115.679a1.03,1.03,0,0,1-.172-.015,1,1,0,0,1-.814-1.156c.324-1.866.709-3.744,1.144-5.582a1,1,0,1,1,1.946.461c-.426,1.8-.8,3.636-1.119,5.462A1,1,0,0,1,74.255,115.679Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.268,121.366a1.024,1.024,0,0,1-.109-.006,1,1,0,0,1-.887-1.1c.2-1.894.47-3.8.789-5.667a1,1,0,1,1,1.972.337c-.312,1.826-.572,3.692-.772,5.545A1,1,0,0,1,77.268,121.366Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.833,9.359a1,1,0,0,1-.409-1.913c1.822-.816,3.683-1.589,5.532-2.3a1,1,0,0,1,.716,1.867c-1.815.7-3.642,1.454-5.43,2.255A1,1,0,0,1,73.833,9.359Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.4,15.292a1,1,0,0,1-.461-1.888c1.766-.916,3.569-1.788,5.36-2.594a1,1,0,1,1,.821,1.823c-1.758.792-3.528,1.648-5.261,2.546A1,1,0,0,1,70.4,15.292Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.36,21.378a1,1,0,0,1-.511-1.86c1.7-1.008,3.44-1.978,5.177-2.883a1,1,0,0,1,.924,1.773c-1.7.888-3.414,1.84-5.081,2.829A.993.993,0,0,1,67.36,21.378Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.708,27.6a1,1,0,0,1-.56-1.829c1.631-1.1,3.308-2.164,4.983-3.163a1,1,0,1,1,1.024,1.718c-1.644.98-3.289,2.024-4.889,3.1A.994.994,0,0,1,64.708,27.6Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.445,33.937a1,1,0,0,1-.607-1.8c1.562-1.189,3.168-2.344,4.776-3.433a1,1,0,1,1,1.121,1.656c-1.577,1.068-3.154,2.2-4.686,3.368A.994.994,0,0,1,62.445,33.937Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.572,40.372a1,1,0,0,1-.651-1.759c1.482-1.271,3.016-2.514,4.558-3.693a1,1,0,0,1,1.215,1.589c-1.512,1.157-3.017,2.376-4.471,3.623A1,1,0,0,1,60.572,40.372Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.088,46.886a1,1,0,0,1-.694-1.72c1.406-1.354,2.862-2.681,4.328-3.943a1,1,0,1,1,1.3,1.516c-1.438,1.238-2.866,2.54-4.245,3.868A1,1,0,0,1,59.088,46.886Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.995,53.46a1,1,0,0,1-.734-1.679c1.324-1.432,2.7-2.839,4.086-4.181a1,1,0,0,1,1.391,1.438c-1.361,1.316-2.709,2.7-4.008,4.1A1,1,0,0,1,57.995,53.46Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.291,60.078a1,1,0,0,1-.772-1.635c1.238-1.507,2.527-2.99,3.833-4.408a1,1,0,0,1,1.472,1.354c-1.28,1.391-2.544,2.845-3.759,4.323A1,1,0,0,1,57.291,60.078Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.976,66.72a1,1,0,0,1-.808-1.588c1.146-1.574,2.346-3.129,3.568-4.623a1,1,0,1,1,1.548,1.267c-1.2,1.464-2.375,2.989-3.5,4.533A1,1,0,0,1,56.976,66.72Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.052,73.367a1,1,0,0,1-.841-1.54C57.261,70.19,58.368,68.567,59.5,67a1,1,0,0,1,1.619,1.174c-1.111,1.534-2.2,3.125-3.227,4.73A1,1,0,0,1,57.052,73.367Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.517,80a1,1,0,0,1-.871-1.489c.951-1.695,1.961-3.381,3-5.013a1,1,0,0,1,1.686,1.076c-1.021,1.6-2.011,3.253-2.944,4.915A1,1,0,0,1,57.517,80Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.373,86.6a1,1,0,0,1-.9-1.437c.849-1.749,1.758-3.494,2.7-5.187a1,1,0,1,1,1.747.975c-.926,1.66-1.817,3.371-2.649,5.085A1,1,0,0,1,58.373,86.6Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.618,93.158a1,1,0,0,1-.924-1.382c.746-1.806,1.55-3.605,2.39-5.348a1,1,0,1,1,1.8.869c-.824,1.708-1.612,3.471-2.343,5.241A1,1,0,0,1,59.618,93.158Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.253,99.644a1,1,0,0,1-.946-1.326c.635-1.849,1.331-3.7,2.066-5.492a1,1,0,1,1,1.851.759c-.721,1.76-1.4,3.571-2.025,5.384A1,1,0,0,1,61.253,99.644Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.278,106.042a1.014,1.014,0,0,1-.267-.037,1,1,0,0,1-.7-1.23c.524-1.9,1.106-3.787,1.73-5.621a1,1,0,1,1,1.894.645c-.612,1.8-1.183,3.651-1.7,5.51A1,1,0,0,1,63.278,106.042Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.692,112.336a1,1,0,0,1-.979-1.206c.4-1.924.87-3.854,1.383-5.735a1,1,0,0,1,1.93.526c-.5,1.844-.959,3.735-1.356,5.62A1,1,0,0,1,65.692,112.336Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.5,118.507a1.04,1.04,0,0,1-.145-.01,1,1,0,0,1-.846-1.133c.284-1.952.628-3.914,1.025-5.833a1,1,0,1,1,1.959.405c-.389,1.88-.727,3.8-1,5.714A1,1,0,0,1,68.5,118.507Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.69,124.536c-.027,0-.054,0-.081,0a1,1,0,0,1-.917-1.077c.158-1.969.378-3.958.654-5.912a1,1,0,1,1,1.98.28c-.271,1.914-.486,3.862-.641,5.792A1,1,0,0,1,71.69,124.536Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.049,7.575a1,1,0,0,1-1-.956c-.075-1.689-.112-3.408-.112-5.108a1,1,0,1,1,2,0c0,1.67.037,3.359.11,5.02a1,1,0,0,1-.955,1.043Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.567,14.541a1,1,0,0,1-.993-.893c-.237-2.192-.413-4.42-.524-6.623a1,1,0,1,1,2-.1c.11,2.165.283,4.355.516,6.509a1,1,0,0,1-.887,1.1A1.024,1.024,0,0,1,52.567,14.541Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.532,21.66a1,1,0,0,1-.984-.831c-.371-2.159-.686-4.362-.937-6.548a1,1,0,1,1,1.987-.228c.246,2.15.556,4.315.92,6.437a1,1,0,0,1-.816,1.155A.968.968,0,0,1,49.532,21.66Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.943,28.911a1,1,0,0,1-.972-.77c-.5-2.127-.952-4.3-1.336-6.455a1,1,0,0,1,1.969-.351c.377,2.119.82,4.254,1.313,6.345a1,1,0,0,1-.743,1.2A.987.987,0,0,1,46.943,28.911Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.8,36.275a1,1,0,0,1-.957-.711c-.627-2.08-1.208-4.213-1.724-6.342a1,1,0,0,1,1.943-.472c.508,2.093,1.078,4.191,1.7,6.236a1,1,0,0,1-.668,1.247A1.013,1.013,0,0,1,44.8,36.275Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.1,43.73a1,1,0,0,1-.938-.654c-.751-2.034-1.458-4.124-2.1-6.212a1,1,0,1,1,1.911-.589c.633,2.054,1.328,4.109,2.065,6.109A1,1,0,0,1,43.1,43.73Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.853,51.254a1,1,0,0,1-.916-.6c-.868-1.977-1.7-4.018-2.465-6.065a1,1,0,1,1,1.872-.7c.756,2.013,1.571,4.02,2.424,5.964a1,1,0,0,1-.915,1.4Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.048,58.826a1,1,0,0,1-.891-.545c-.985-1.926-1.933-3.911-2.818-5.9a1,1,0,1,1,1.827-.812c.871,1.956,1.8,3.909,2.771,5.8a1,1,0,0,1-.889,1.455Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.689,66.426a1,1,0,0,1-.863-.493c-1.095-1.861-2.157-3.785-3.159-5.719a1,1,0,0,1,1.776-.92c.985,1.9,2.03,3.795,3.106,5.625a1,1,0,0,1-.861,1.507Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.776,74.033a1,1,0,0,1-.832-.443c-1.2-1.8-2.376-3.654-3.488-5.523a1,1,0,0,1,1.719-1.022c1.094,1.838,2.248,3.667,3.432,5.433a1,1,0,0,1-.83,1.557Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.309,81.625a1,1,0,0,1-.8-.4c-1.3-1.718-2.583-3.5-3.807-5.311A1,1,0,0,1,38.36,74.8c1.2,1.776,2.463,3.534,3.744,5.224a1,1,0,0,1-.8,1.6Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.287,89.181a1,1,0,0,1-.761-.351c-1.407-1.646-2.79-3.357-4.113-5.084A1,1,0,1,1,39,82.53c1.3,1.7,2.662,3.382,4.045,5a1,1,0,0,1-.76,1.649Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.711,96.681a1,1,0,0,1-.721-.308c-1.5-1.565-2.986-3.2-4.408-4.843A1,1,0,0,1,40.1,90.223c1.4,1.622,2.857,3.225,4.335,4.765a1,1,0,0,1-.721,1.692Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.582,104.1a1,1,0,0,1-.68-.267c-1.594-1.479-3.172-3.022-4.69-4.588a1,1,0,0,1,1.436-1.393c1.494,1.541,3.046,3.06,4.615,4.515a1,1,0,0,1-.68,1.733Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.9,111.425a1,1,0,0,1-.636-.229c-1.674-1.382-3.343-2.835-4.96-4.321a1,1,0,1,1,1.353-1.473c1.592,1.461,3.234,2.892,4.881,4.252a1,1,0,0,1-.637,1.771Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.66,118.628a1,1,0,0,1-.59-.193c-1.763-1.292-3.52-2.652-5.22-4.041a1,1,0,1,1,1.266-1.549c1.673,1.367,3.4,2.7,5.137,3.977a1,1,0,0,1-.592,1.807Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.868,125.689a.994.994,0,0,1-.542-.161c-1.84-1.191-3.68-2.452-5.468-3.749a1,1,0,0,1,1.174-1.619c1.76,1.276,3.57,2.518,5.381,3.689a1,1,0,0,1-.544,1.839Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.7,10.614a1,1,0,0,1-1-.933c-.142-2.124-.223-4.289-.241-6.434a1,1,0,0,1,.992-1.008h.008a1,1,0,0,1,1,.992c.018,2.106.1,4.232.236,6.317a1,1,0,0,1-.931,1.064C61.745,10.613,61.722,10.614,61.7,10.614Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.391,17.233a1,1,0,0,1-.99-.87c-.275-2.1-.494-4.246-.648-6.373a1,1,0,1,1,2-.146c.152,2.089.366,4.195.637,6.259a1,1,0,0,1-.862,1.122A1.084,1.084,0,0,1,58.391,17.233Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.507,24a1,1,0,0,1-.98-.808c-.4-2.069-.755-4.187-1.043-6.294a1,1,0,1,1,1.981-.271c.283,2.069.628,4.149,1.025,6.181A1,1,0,0,1,55.507,24Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.047,30.89a1,1,0,0,1-.967-.748c-.531-2.037-1.011-4.121-1.427-6.2a1,1,0,0,1,1.961-.394c.409,2.037.881,4.084,1.4,6.085a1,1,0,0,1-.968,1.252Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.011,37.889a1,1,0,0,1-.951-.69c-.652-1.995-1.257-4.041-1.8-6.08a1,1,0,1,1,1.933-.514c.533,2,1.127,4.013,1.768,5.972a1,1,0,0,1-.951,1.311Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.4,44.973a1,1,0,0,1-.931-.633c-.77-1.95-1.5-3.951-2.16-5.946a1,1,0,1,1,1.9-.631c.651,1.961,1.365,3.927,2.122,5.842a1,1,0,0,1-.93,1.368Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.209,52.123a1,1,0,0,1-.907-.578c-.883-1.893-1.727-3.843-2.509-5.8A1,1,0,0,1,46.65,45c.769,1.919,1.6,3.835,2.465,5.7a1,1,0,0,1-.906,1.422Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.444,59.319a1,1,0,0,1-.881-.524c-.993-1.837-1.95-3.731-2.845-5.63a1,1,0,0,1,1.809-.853c.88,1.866,1.821,3.728,2.8,5.532a1,1,0,0,1-.879,1.476Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.1,66.542a1,1,0,0,1-.851-.474c-1.1-1.773-2.166-3.606-3.171-5.447a1,1,0,0,1,1.755-.959c.989,1.81,2.037,3.611,3.116,5.354a1,1,0,0,1-.849,1.526Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.186,73.771a1,1,0,0,1-.819-.424c-1.2-1.7-2.368-3.466-3.484-5.251a1,1,0,0,1,1.7-1.061c1.1,1.754,2.25,3.491,3.425,5.16a1,1,0,0,1-.817,1.576Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.691,80.985a1,1,0,0,1-.783-.377c-1.294-1.628-2.568-3.324-3.787-5.04a1,1,0,0,1,1.631-1.158c1.2,1.687,2.45,3.353,3.722,4.953a1,1,0,0,1-.782,1.623Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.621,88.167a1,1,0,0,1-.746-.333c-1.389-1.552-2.76-3.171-4.077-4.814a1,1,0,0,1,1.561-1.251C46.653,83.382,48,84.974,49.366,86.5a1,1,0,0,1-.745,1.667Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.975,95.293A1,1,0,0,1,49.269,95c-1.482-1.475-2.947-3.014-4.355-4.576A1,1,0,0,1,46.4,89.087c1.384,1.535,2.824,3.048,4.281,4.5a1,1,0,0,1-.706,1.709Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.752,102.347a1,1,0,0,1-.663-.251c-1.568-1.389-3.123-2.844-4.623-4.324a1,1,0,1,1,1.405-1.424c1.474,1.455,3,2.885,4.543,4.25a1,1,0,0,1-.664,1.749Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.953,109.306a.994.994,0,0,1-.618-.214c-1.648-1.3-3.289-2.664-4.877-4.06a1,1,0,1,1,1.32-1.5c1.562,1.372,3.175,2.714,4.794,3.991a1,1,0,0,1-.619,1.786Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.578,116.15a.992.992,0,0,1-.571-.18c-1.727-1.205-3.449-2.478-5.121-3.784a1,1,0,1,1,1.231-1.576c1.644,1.284,3.337,2.535,5.034,3.72a1,1,0,0,1-.573,1.82Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.627,122.861a1,1,0,0,1-.523-.148c-1.8-1.109-3.6-2.286-5.353-3.5a1,1,0,0,1,1.139-1.645c1.72,1.191,3.491,2.348,5.263,3.438a1,1,0,0,1-.525,1.852Z",
  fill: "#d9e2e9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.215,127.633a1,1,0,0,1-.868-.5A119.913,119.913,0,0,1,70.876,1.108a1,1,0,0,1,1.658,1.119,117.9,117.9,0,0,0-4.453,123.908,1,1,0,0,1-.866,1.5Z",
  fill: "#da2a47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64,128a63.98,63.98,0,1,1,3.22-.08C66.155,127.973,65.072,128,64,128ZM64,2a62,62,0,0,0,0,124c1.039,0,2.089-.026,3.121-.077A62,62,0,0,0,64,2Z",
  fill: "#2f3a5a"
}));

function SvgCricketBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricketBall);
export default __webpack_public_path__ + "static/media/cricket-ball.1b5f2646.svg";
export { ForwardRef as ReactComponent };